import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { SpinnerService } from 'shared-components';
import { DataService } from '../../../../services/data.service';

@Component({
    selector: 'app-estadisticas-designacion-pd',
    templateUrl: './estadisticas-designacion-pd.component.html'
})
export class EstadisticasDesignacionPDComponent implements OnChanges, OnInit {

    public estadisticas;
    public tipoEstadisticas = 1;
    public gridModal = false;
    public gridTitle;
    public parentDataGrid;
    public parentCurrentTab;
    public dataDesignaciones;

    @Input() graficasDesignaciones;
    @Input() allDataDesignaciones; // disponer, para cada tabla, de todas las propiedades agrupadas en objetos, y no en arrays separados
    @Input() filtrado;

    @Output() showWarning = new EventEmitter<any>(true);

    constructor(
        private readonly _dataService: DataService,
        private readonly _spinnerService: SpinnerService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['allDataDesignaciones']) {
            if (changes['allDataDesignaciones'].currentValue) {
                this.dataDesignaciones = changes['allDataDesignaciones'].currentValue;
            }
        }
    }

    ngOnInit() {}

    public async showDesignacionesPais() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 1;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab1: true
        });
    }

    public async showDesignacionesDenominacion() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 2;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab2: true
        });
    }

    public async showDesignacionesCampanya() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 3;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false,
            tab3: true
        });
    }

    public async showKilosCampanya() {
        if (this.filtrado) {
            this._spinnerService.showSpinner();
            await this.delay(1);
            this._spinnerService.hideSpinner();
        }
        this.tipoEstadisticas = 7;
        this.showWarning.emit({
            filtroAnyo: false,
            filtroPais: false,
            filtroDenominacion: false,
            filtroEtiquetador: false
        });
    }

    public delay(ms: number) {
        return new Promise( resolve => setTimeout(resolve, ms) );
    }

    public showGrid(title: string, gridArray: Array<any>, currentTab: string, roundPercentage: string, filterBy?: string) {
        this.gridTitle = title;
        this.parentCurrentTab = currentTab;

        // Filtrado para la pestaña Kilos / Campañas
        if (currentTab === 'kgCampanyasPaises') {
            this.parentDataGrid = gridArray.filter(object => {
                return object.desDenominacion === filterBy;
            })
        } else if (currentTab === 'kgCampanyasDenominaciones') {
            this.parentDataGrid = gridArray.filter(object => {
                return object.desPais === filterBy;
            })
        // Resto de pestañas
        } else if (currentTab === 'regularTab') {
            // Filtrado de valores 0
            const filteredGridArray = gridArray.filter(object => {
                if (object.numDesignaciones) {
                    return object.numDesignaciones > 0;
                } else if (object.numero) {
                    return object.numero > 0;
                }
            })

            // Redondeo de los porcentajes para que coincidan con los mostrados en los donuts/barras
            if (roundPercentage === 'donut') {
                const percentagesAltered = filteredGridArray.map(obj => {
                    return {
                        ...obj,
                        porcentajeDesignaciones: obj.porcentajeDesignaciones ? obj.porcentajeDesignaciones.toFixed(1) : obj.porcentaje.toFixed(1)
                    }
                })
                this.parentDataGrid = percentagesAltered;
            } else if (roundPercentage === 'bars') {
                const percentagesAltered = filteredGridArray.map(obj => {
                    return {
                        ...obj,
                        porcentajeDesignaciones: obj.porcentajeDesignaciones ? Math.round(obj.porcentajeDesignaciones) : Math.round(obj.porcentaje)
                    }
                })
                this.parentDataGrid = percentagesAltered;
            }
        }

        this.gridModal = true;
    }

    public hideModal() {
        this.gridModal = false;
    }
}
